module.exports = __webpack_public_path__ + "img/copy-pay-preview.cf446cfa.png";